import { ProductVariant, SelectedColumn, CatalogColumn } from './types'
import { getCellValue } from './formatters'
import { formatLinkingStatusForCSV } from 'src/app/pages/listing/components/linkingStatusUtils'

const CSV_EXCLUDED_FIELDS = new Set(['link_actions', 'link_action', 'grouped_lite_actions'])

const formatBooleanYesNo = (value: any) => {
  if (value === true) return 'Yes'
  if (value === false) return 'No'
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase()
    if (normalized === 'true') return 'Yes'
    if (normalized === 'false') return 'No'
  }
  return value
}

export const exportToCSV = (
  data: ProductVariant[],
  selectedColumns: SelectedColumn[],
  getColumnByField: (field: string) => CatalogColumn | undefined,
  channelId: string | number,
  tabsData: any[] = []
) => {
  if (data.length === 0) {
    alert('No data to export')
    return
  }

  // Sort columns by order
  const orderedColumns = [...selectedColumns]
    .filter((col) => !CSV_EXCLUDED_FIELDS.has(col.field))
    .sort((a, b) => a.order - b.order)

  // Build CSV header
  const headers = orderedColumns
    .map((col) => {
      const catalogCol = getColumnByField(col.field)
      return catalogCol?.label || col.field
    })
    .map((header) => `"${header}"`)
    .join(',')

  // Build CSV rows
  const rows = data.map((row) => {
    return orderedColumns
      .map((col) => {
        const value =
          col.field === 'linking_status'
            ? formatLinkingStatusForCSV(row, tabsData)
            : formatBooleanYesNo(getCellValue(row, col.field))
        
        // Handle null/undefined
        if (value === null || value === undefined) return ''
        
        // Handle objects (e.g., price objects)
        let stringValue: string
        if (typeof value === 'object' && value !== null) {
          if ('value' in value) {
            stringValue = String(value.value)
          } else {
            stringValue = JSON.stringify(value)
          }
        } else {
          stringValue = String(value)
        }
        
        // Escape quotes
        stringValue = stringValue.replace(/"/g, '""')
        return `"${stringValue}"`
      })
      .join(',')
  })

  // Combine header and rows
  const csvContent = `\uFEFF${[headers, ...rows].join('\n')}`

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  
  const date = new Date().toISOString().split('T')[0]
  const filename = `products-${channelId}-${date}.csv`
  
  link.href = URL.createObjectURL(blob)
  link.download = filename
  link.click()
  
  // Cleanup
  URL.revokeObjectURL(link.href)
}
